import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Input, RemovableBadge } from '@wit-support/ui';
import { FieldShell } from './field-shell.js';
export function ChipInputWidget(props) {
    const { field, fieldState, meta, label, description, hint, readonly, disabled } = props;
    const [draft, setDraft] = React.useState('');
    const values = Array.isArray(field.value) ? field.value : [];
    const add = (v) => {
        const next = v.trim();
        if (!next)
            return;
        if (values.includes(next)) {
            setDraft('');
            return;
        }
        field.onChange([...values, next]);
        setDraft('');
    };
    const removeAt = (idx) => {
        const next = values.slice();
        next.splice(idx, 1);
        field.onChange(next);
    };
    return (_jsx(FieldShell, { meta: meta, fieldState: fieldState, label: label, description: description, hint: hint, htmlFor: field.name, children: _jsxs("div", { className: "flex flex-col gap-2", children: [_jsx(Input, { id: field.name, name: field.name, ref: field.ref, value: draft, placeholder: meta.placeholder ?? 'Type and press Enter', readOnly: readonly ?? meta.readonly, disabled: disabled, onBlur: field.onBlur, onChange: (e) => setDraft(e.target.value), onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            add(draft);
                        }
                        else if (e.key === 'Backspace' && draft === '' && values.length > 0) {
                            removeAt(values.length - 1);
                        }
                    } }), values.length > 0 ? (_jsx("div", { className: "flex flex-wrap gap-1.5", children: values.map((v, i) => (_jsx(RemovableBadge, { onRemove: () => removeAt(i), removeAriaLabel: `Remove ${v}`, disabled: disabled ?? false, children: v }, `${v}-${i}`))) })) : null] }) }));
}
//# sourceMappingURL=chip-input.js.map